import React, { useState, useCallback } from 'react';
import cx from 'classnames';
import { CloseIcon, ErrorIcon, DoneIcon } from '@move-ui/icons-asset-catalog';
import Text, { TextSize } from '@move-ui/text';
import styles from './SnackBarContent.module.css';
// eslint-disable-next-line @typescript-eslint/naming-convention
export var SNACKBAR_TYPE;
(function (SNACKBAR_TYPE) {
    SNACKBAR_TYPE["SUCCESS"] = "SUCCESS";
    SNACKBAR_TYPE["ERROR"] = "ERROR";
    SNACKBAR_TYPE["DEFAULT"] = "DEFAULT";
})(SNACKBAR_TYPE || (SNACKBAR_TYPE = {}));
const getStyle = (appearance) => {
    switch (appearance) {
        case SNACKBAR_TYPE.SUCCESS:
            return styles.successComponent;
        case SNACKBAR_TYPE.ERROR:
            return styles.errorComponent;
        default:
            return styles.defaultComponent;
    }
};
export const SnackBarContent = ({ children, className, textSize = TextSize.M, textColor = 'neutral-800', bold, closeable, onClose, appearance = SNACKBAR_TYPE.DEFAULT }) => {
    const [visible, setVisible] = useState(true);
    const onSnackbarClose = useCallback(() => {
        onClose === null || onClose === void 0 ? void 0 : onClose();
        setVisible(false);
    }, [setVisible, onClose]);
    if (!visible) {
        return null;
    }
    const backgroundStyle = getStyle(appearance);
    return (React.createElement("div", { className: cx(styles.component, backgroundStyle, className, {
            [styles.isCloseable]: closeable
        }), role: "alert", "data-testid": `${appearance.toLowerCase()}-notification` },
        React.createElement("div", { className: cx({ [styles.leaveSpaceForIcon]: closeable }) },
            React.createElement("div", { className: styles.textWrapper },
                appearance === SNACKBAR_TYPE.SUCCESS && (React.createElement("div", { className: styles.infoIconWrapper },
                    React.createElement(DoneIcon, { className: styles.infoIcon }))),
                appearance === SNACKBAR_TYPE.ERROR && (React.createElement("div", { className: styles.infoIconWrapper },
                    React.createElement(ErrorIcon, { className: styles.infoIcon }))),
                React.createElement(Text, { size: textSize, color: textColor, bold: bold, className: styles.text }, children))),
        closeable && (React.createElement("div", { className: styles.iconWrapper, "data-testid": "CloseableIcon" },
            React.createElement(CloseIcon, { className: styles.icon, onClick: onSnackbarClose })))));
};
//# sourceMappingURL=SnackBarContent.js.map